<div class="main-layout flex-column w-100 d-flex vh-100">

  <div class="container mt-4">

    <ng-container *ngIf="!showMessage">
      <app-express-retail-form [comunas]="comunas"></app-express-retail-form>
    </ng-container>

    <ng-container *ngIf="showMessage">
      <app-express-full-mensaje [comunas]="comunas"></app-express-full-mensaje>

      <div class="row">
        <div class="col-12">
          <div class="row d-flex justify-content-center">
            <div class="col-6 col-md-4">
              <button (click)="toogleMessage()" type="button" class="my-md-none my-3 btn btn-success w-100"> Continuar
              </button>
            </div>
          </div>
        </div>
      </div>

    </ng-container>


    <app-loader-full *ngIf="isLoading"></app-loader-full>


  </div>
  <app-auth-footer class="mt-auto"></app-auth-footer>

</div>